const SET_OFFERS = 'SET_OFFERS';
const REMOVE_OFFER = 'REMOVE_OFFER';
const TOGGLE_OFFER_FAVOURITE_STATUS = 'TOGGLE_OFFER_FAVOURITE_STATUS';
const SET_AGREEMENT = 'SET_AGREEMENT';


const setOffers = offers => ({
  type: SET_OFFERS,
  payload: {
    offers
  }
});

const toggleOfferFavouriteStatus = ({ offerId, isFavourite }) => ({
  type: TOGGLE_OFFER_FAVOURITE_STATUS,
  payload: {
    offerId,
    isFavourite
  }
});

const removeOffer = offerId => ({
  type: REMOVE_OFFER,
  payload: {
    offerId
  }
});


const setProfilingAgreement = hasProfilingAgreement => ({
  type: SET_AGREEMENT,
  payload: {
    hasProfilingAgreement
  }
});

export {
  SET_OFFERS,
  REMOVE_OFFER,
  TOGGLE_OFFER_FAVOURITE_STATUS,
  SET_AGREEMENT,
  setOffers,
  toggleOfferFavouriteStatus,
  removeOffer,
  setProfilingAgreement
};
